import request from "./request";

// 登录接口
export function login(data) {
  return request({
    url: "/api/login/pcLogin",
    method: "post",
    data
  });
}

export function loginout(data) {
  return request({
    url: "/api/member/logout",
    method: "post",
    data
  });
}

// 注册接口
export function register(data) {
  return request({
    url: "/api/login/register",
    method: "post",
    data
  });
}

// export function resetPassword(data) {
//   return request({
//     url: "/api/common/resetPassword",
//     method: "post",
//     data
//   });
// }

export function sendEmail(data) {
    return request({
      url: "/api/login/sendEmail",
      method: "post",
      data
    });
}
  
// 图形验证码
export function getCaptchaImage() {
  return request({
    url: "/api/login/captchaImage",
    method: "get",
  });
}

export function getInfo() {
  return request({
    // url: "/api/member/memberInfo",
    url: "/api/nzMember/memberInfo",
    method: "get",
  });
}

export function getRouters() {
  return request({
    url: "/api/menuRouters/getRouters",
    method: "get",
  });
}

export function uploadFile(data) {
  return request({
    url: "/api/common/upload",
    method: "post",
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    data
  });
}
// oss图片上传
export function uploadImg(data) {
  return request({
    url: "/api/common/ossPngUpload",
    method: "post",
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    data
  });
}

// 查询对应字典
export function dictList(data) {
  return request({
    url: "/api/common/dictInfo/"+data,
    method: "get",
  });
}

// 登录状态
export function userState(data) {
  return request({
    url: "/api/chatMember/userConfigState",
    method: "post",
    data
  });
}

export function noticeList(data) {
  return request({
    url: "/api/notice/memberNoticeList",
    method: "get",
    params: data
  });
}

export function noticeDetail(id) {
  return request({
    url: "/api/notice/memberNoticeInfo/"+id,
    method: "get",
  });
}

export function memberPassword(data) {
  return request({
    url: "/api/chatMember/memberPassword",
    method: "post",
    data
  });
}

export function workLanguageEdit(data) {
  return request({
    url: "/api/chatMember/workLanguageEdit",
    method: "post",
    data
  });
}

export function improveEdit(data) {
  return request({
    url: "/api/chatMember/improveEdit",
    method: "post",
    data
  });
}

export function improveInfo() {
  return request({
    url: "/api/chatMember/improveInfo",
    method: "get",
  });
}

// Excel下载
export function download(query) {
  return request({
    url: "/common/download",
    method: "get",
    params: query
  });
}

// 快速操作指引
export function quickGuide() {
  return request({
    url: "/api/nzMember/operationList",
    method: "get"
  });
}